// snackbarStore.js
import { create } from 'zustand';

// Create a store for snackbar state
const useMessageDialog = create((set) => ({
  open: false,
  is_minimized: false,
  resource: '',
  resource_id: '',
  customer_id: '',
  customer_name: '',
  customer_phone: '',
  
  // Show the snackbar
  showDialog: ({customer_id, customer_name, customer_phone, resource, resource_id}) => 
    set({ open: true, is_minimized: false, customer_id, customer_name, customer_phone, resource, resource_id }),
  
  // Hide the snackbar
  hideDialog: () => set({ open: false, is_minimized: false, customer_id: '', customer_name: '', customer_phone: '', resource: '', resource_id: ''}),

  toggleMinimize: () => set((state) => ({ is_minimized: !state.is_minimized }))
}));

export default useMessageDialog;
